import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import qs from 'query-string';

import Content from 'src/componentes/pages/content';
import List from 'src/componentes/list';
import ListColumn from 'src/componentes/list/list-column';
import { COLUNAS, FILTROS } from 'src/utils/constants';
import Alert from 'src/componentes/message-box/alert';
import ContentManager from 'src/componentes/content-manager';
import ValidacaoRestricao from 'src/paginas/item/validacao-restricao';
import { capitalizeFirstLetter } from 'src/utils/string';
import useAuth from 'src/hooks/useAuth';

import Edit from './Edit';
import SearchSchema from './SearchSchema';
import Search from './Search';

const FluxoAprovacaoGenericoList = (props) => {
  const intl = useIntl();

  const { terms: resources } = useAuth();
  const { showModal } = props;

  useEffect(() => {
    if (showModal) return;

    const id = Number(qs.parse(window.location.search).id);
    if (!id || Number.isNaN(id)) return;

    ContentManager.addContent(<Edit item={{ id }} />);
  }, [showModal]);

  const handleDelete = (deleted) => {
    if (deleted) {
      ContentManager.addContent(
        <Alert
          title={intl.formatMessage({ id: 'sucesso' })}
          message={intl.formatMessage({
            id: 'label.registroExcluidoComSucesso',
          })}
          deleted={deleted}
        />
      );
    }
  };

  const handlePreDelete = (item) => {
    ContentManager.addContent(
      <ValidacaoRestricao
        url="/FluxoAprovacaoGenerico/ValidarRestricoesAoRemover"
        urlExclusao="/FluxoAprovacaoGenerico/Remove"
        item={item}
        onClose={handleDelete}
      />
    );
  };

  const renderTipo = (item) => {
    if (!item.tipoFluxoAprovacao) return;

    return <span>{item.tipoFluxoAprovacao.descricao}</span>;
  };

  const renderNome = (item, handleEditClose) => (
    <button
      type="button"
      className="btn btn-link p-0 text-left font-weight-bold"
      onClick={() =>
        ContentManager.addContent(
          <Edit item={item} handleClose={handleEditClose} />
        )
      }
    >
      {item.nome}
    </button>
  );

  return (
    <Content titulo={intl.formatMessage({ id: 'fluxosAprovacao' })}>
      <List
        url="/FluxoAprovacaoGenerico"
        editComponent={Edit}
        showExport
        showSearch
        searchSchema={SearchSchema}
        searchComponent={<Search />}
        filtroId={FILTROS.FLUXO_APROVACAO_GENERICO}
        tag={COLUNAS.FLUXO_APROVACAO_GENERICO}
        onDeleting={handlePreDelete}
        filterDrawer={true}
        ignoreChipFilterProperties={['validarPermissoes']}
        {...props}
      >
        <ListColumn
          headerText={intl.formatMessage({ id: 'idIntegracao' })}
          valueField="idIntegracao"
          required
          default
        />
        <ListColumn
          headerText={intl.formatMessage({ id: 'nome' })}
          valueField="nome"
          valueFunction={renderNome}
          required
          default
        />
        <ListColumn
          headerText={intl.formatMessage({ id: 'numeroEtapas' })}
          valueField="numeroEtapas"
          default
        />
        <ListColumn
          headerText={capitalizeFirstLetter(resources.area)}
          valueField="organizacao"
        />
        <ListColumn
          headerText={intl.formatMessage({ id: 'tipo' })}
          valueField="tipoFluxoAprovacao"
          valueFunction={renderTipo}
          default
        />
      </List>
    </Content>
  );
};

export default FluxoAprovacaoGenericoList;
